export default "<p>alert works!</p>\r\n"